<template>
  <v-toolbar-items>
    <v-btn
      v-for="(exp, index) in exportsData"
      :key="index"
      text
      icon
      :color="color || exp.COLOR || 'primary'"
      :href="getDownloadLink(exp.PARAMS)"
      target="_blank"
      :title="exp.TXT"
    >
      <v-icon>{{ exp.ICON || 'mdi-file' }}</v-icon>
    </v-btn>
  
  </v-toolbar-items>
</template>

<script>
export default {
  name: 'AedExportIcons',
  props: {
    exportsData: {
      type: Array,
      required: true,
      default: () => []
    },
    // Entspricht deinem 'this.webservice'
    baseUrl: {
      type: String,
      required: true
    },
    // Optionaler Suchstring
    searchString: {
      type: String,
      default: ''
    },
    // Optionales Filter-Objekt
    filters: {
      type: Object,
      default: () => ({})
    },
    // Farbe überschreiben
    color: {
      type: String,
      default: ''
    }
  },
  methods: {
    getDownloadLink(params) {
      if (!this.baseUrl) return '#';


      const fileFormat =  params;

      // 2. Basis-Link analog zu deiner alten Funktion aufbauen
      let link = `${this.baseUrl}?&opcode=L&${fileFormat}`;

      // 3. Suchstring encodieren und anhängen
      if (this.searchString) {
        link += '&filter=' + encodeURIComponent(this.searchString);
      }

      // 4. Filter-Objekt durchlaufen und anhängen
      if (this.filters) {
        for (const key in this.filters) {
          if (Object.prototype.hasOwnProperty.call(this.filters, key)) {
            const value = this.filters[key];
            if (value !== '' && value !== null && value !== undefined) {
              link += `&${key}=${value}`;
            }
          }
        }
      }

      return link;
    }
  }
};
</script>